import { Link } from 'react-router-dom'
import styled from 'styled-components'
import ErrorSvg from '../components/ErrorSvg'
import TextAnimation from '../components/TextAnimation'

export default function Error() {
  return (
    <Container>
      <ErrorSvg />
      <div>
        <TextAnimation
          style={{ marginBottom: '-30px' }}
          text="404"
        />
        <TextAnimation
          style={{ marginBottom: '-10px' }}
          size={2}
          text={`UH OH! You're lost.`}
        />
        <TextAnimation
          style={{ maxWidth: '400px' }}
          size={1}
          text="The page you are looking for does not exist. How you got here is a mystery. But you can click the button below to go back to the homepage."
        />
        <Link
          className="go-home"
          to="/"
        >
          HOME
        </Link>
      </div>
      {/* <Sakana/> */}
    </Container>
  )
}

const Container = styled.div`
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
  }
`
